import React, {useEffect, useState} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {Row, Col} from 'reactstrap';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import {
  changeHandler,
  validateHandler,
  getTimeSlots,
  getTimeSlotsFromDate,
  getIbcTimeSlots,
  startLoading,
} from './IBCTechnicianArrivalTimeSlice';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader, showOverlay} from '../../../Shared/Loader/LoaderSlice';
import {addDays} from './../../../../utilities/dateUtils';
import {getRecaptchaToken} from './../../../../utilities/recaptcha/recaptcha';
import Config from '../../../../Config';

const IBCTechnicianArrivalTime = (props) => {
  const [isShowIbcDropDown, setIsShowIbcDropDown] = useState(false);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.showAppLoader();
      props.showOverlay(true);
    }

    if (props.form.ibcArrivalTime == '') {
      if (props.selectedAddress.infrastructure && !props.isCustomerConnectedToIbc) {
        let today = new Date();
        let params = {};

        params = {
          city: props.selectedAddress.city,
          zipCode: props.selectedAddress.zipCode,
          typeName: getTypeName,
          fromDate: addDays(today, 1), //2020-11-30T00:00:00+02:00
          addDays: '30',
        };
        props.getIbcTimeSlots(params);
      }

      if (props.isCustomerConnectedToIbc) {
        getTechnicianSlots();
      }
    }
  }, []);

  useEffect(() => {
    const isAddressConnectedToIBC = props.selectedAddress.infrastructure.tashtitType == 'IBC';
    if (isAddressConnectedToIBC && !props.isCustomerConnectedToIbc) {
      setIsShowIbcDropDown(true);
    } else {
      setIsShowIbcDropDown(false);
    }
  }, [props.isCustomerConnectedToIbc, props.selectedAddress.infrastructure]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        getTechnicianSlotsFromDate();
      }
    },
    [props.form.ibcArrivalTime]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.isLoading == false) {
          props.showOverlay(false);
          props.hideAppLoader();
        }
      }
    },
    [props.form.timeSlots]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.isLoading == false) {
          props.showOverlay(false);
          props.hideAppLoader();
        }
      }
    },
    [props.form.ibcTimeSlots]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit && props.onSubmit == true) {
          props.validateHandler(props.form);
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.errorObj != '') {
          props.showOverlay(false);
          props.hideAppLoader();
          props.onError(props.form.errorObj.errorId);
        }
      }
    },
    [props.form.errorObj]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.valid !== '') {
          props.onValid(props.form.valid);
        }
      }
    },
    [props.form.valid]
  );

  const getTypeName = () => {
    let typeName = Config.isTimeSlotsGetFromClick ? 'התקנת TV' : 'התקנת IPTV';

    if (props.selectedAddress.infrastructure.tashtitType) {
      if (props.selectedAddress.infrastructure.tashtitType == 'IBC') typeName = 'התקנת תשתית IBC';

      if (props.selectedAddress.infrastructure.tashtitType == 'FIBER') typeName = 'התקנת תשתית סיבים';
    }

    return typeName;
  };

  async function getTechnicianSlotsFromDate() {
    if (props.form.ibcArrivalTime != '' && props.form.ibcArrivalTime != undefined) {
      let params = {};
      const captchatoken = await getRecaptchaToken('IBCTech');

      params = {
        city: props.selectedAddress.cityName,
        zipCode: props.selectedAddress.zipCode,
        cityCode: props.selectedAddress.city,
        streetCode: props.selectedAddress.street,
        entrance: props.selectedAddress.enter == '' ? ' ' : props.selectedAddress.enter,
        typeName: getTypeName(),
        fromDate: addDays(props.form.ibcArrivalStartDate, 1), //2020-11-30T00:00:00+02:00
        addDays: '12',
        captchaToken: captchatoken,
        flowType: props.saleFlowType,
        otpPhone: props.saleOtpPhone,
      };
      props.getTimeSlotsFromDate(params);
    }
  }

  async function getTechnicianSlots() {
    if (props.selectedAddress) {
      let params = {};
      const token = await getRecaptchaToken('IBCTech');

      params = {
        city: props.selectedAddress.cityName,
        zipCode: props.selectedAddress.zipCode,
        cityCode: props.selectedAddress.city,
        streetCode: props.selectedAddress.street,
        entrance: props.selectedAddress.enter == '' ? ' ' : props.selectedAddress.enter,
        typeName: getTypeName(),
        captchaToken: token,
        flowType: props.saleFlowType,
        otpPhone: props.saleOtpPhone,
      };
      props.getTimeSlots(params);
    }
  }

  function renderDropDownTitle() {
    let value;

    const isAddressConnectedToIBC = props.selectedAddress.infrastructure.tashtitType == 'IBC';

    if (!isShowIbcDropDown || (isAddressConnectedToIBC && props.isCustomerConnectedToIbc)) {
      value = (
        <div>
          <p>תאום יום ושעה</p>
          <p>יש חלונות זמן קבועים עבור הגעת טכנאי</p>
        </div>
      );
    }

    if (isShowIbcDropDown && props.form.ibcArrivalTime == '') {
      value = (
        <div>
          <p></p>
          <p>מחכים שתבחרו מועד ל-Unlimited כדי להציע מועדים להתקנה שלנו...</p>
        </div>
      );
    }

    if (isShowIbcDropDown && props.form.ibcArrivalTime != '') {
      value = (
        <div>
          <p>ומתי נוח שהטכנאי שלנו יגיע?</p>
          <p>צריך להמתין 24 שעות בין הטכנאים כדי לוודא שהתשתית איכותית ויציבה</p>
        </div>
      );
    }

    return value;
  }

  return (
    <div>
      <div className='container-fluid main'>
        <div className='ibc-hours'>
          <Row>
            <Col ms={12}>
              <h1 className='top-title'>{props.subTitle}</h1>
            </Col>
          </Row>
          <Row>
            <Col ms={12}>
              {isShowIbcDropDown == true ? (
                <div className='component-container'>
                  <p>מתי נוח שטכנאי Unlimited יגיע?</p>
                  <p>המועד הקרוב ביותר הוא:</p>
                  <ReactSelect
                    inputProps={{readOnly: true}}
                    isSearchable={false}
                    error={props.form.errors.arrivalTime}
                    getOptionLabel={(option) => option.value}
                    getOptionValue={(option) => option.key}
                    placeholder='בחר מועד'
                    isLoading={props.form.isLoading}
                    value={props.form.ibcTimeSlots.filter((option) => option.key === props.form.ibcArrivalTime)}
                    name='ibcArrivalTime'
                    options={props.form.ibcTimeSlots}
                    onChange={(e) =>
                      props.changeHandler({
                        target: {
                          name: 'ibcArrivalTime',
                          value: e.key,
                          startDate: e.startDate,
                          endDate: e.endDate,
                          calendarId: e.calendarId,
                        },
                        startDate: e.startDate,
                        endDate: e.endDate,
                        form: props.form,
                      })
                    }
                  />
                </div>
              ) : (
                ''
              )}

              <div className='ibc-container'>
                {renderDropDownTitle()}
                <ReactSelect
                  inputProps={{readOnly: true}}
                  isSearchable={false}
                  isDisabled={isShowIbcDropDown && props.form.ibcArrivalTime == '' ? true : false}
                  error={props.form.errors.arrivalTime}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.key}
                  placeholder='בחר מועד'
                  value={props.form.timeSlots.filter((option) => option.key === props.form.arrivalTime)}
                  name='arrivalTime'
                  options={props.form.timeSlots}
                  onChange={(e) =>
                    props.changeHandler({
                      target: {name: 'arrivalTime', value: e.key, startDate: e.startDate, endDate: e.endDate},
                      startDate: e.startDate,
                      endDate: e.endDate,
                      form: props.form,
                    })
                  }
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    form: state.ibcTechnicianArrivalTime.form,
    infrastructure: state.addressForm.infrastructure,
    saleOtpTicketId: state.saleBlock.otpTicketId,
    saleFlowType: state.saleBlock.flowType,
    saleOtpPhone: state.saleBlock.otpPhone,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  getTimeSlots,
  getTimeSlotsFromDate,
  getIbcTimeSlots,
  startLoading,
  hideAppLoader,
  showAppLoader,
  showOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(IBCTechnicianArrivalTime);
